import { render, staticRenderFns } from "./AttendanceApproval.vue?vue&type=template&id=47cc0024&scoped=true"
import script from "./AttendanceApproval.vue?vue&type=script&lang=js"
export * from "./AttendanceApproval.vue?vue&type=script&lang=js"
import style0 from "./AttendanceApproval.vue?vue&type=style&index=0&id=47cc0024&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47cc0024",
  null
  
)

export default component.exports